import { Icon } from '../../../../../shared/ui';
import { iconsData } from '../../../model/iconsData';
import React from 'react';

export const FileItemSvg = ({ extension }) => {
    const foundedIconItem = iconsData.find((obj) => obj.extension === extension);
    if (!foundedIconItem) return <Icon iconName={'fileItemPlaceholder'} />;
    return <Icon iconName={foundedIconItem.iconName} />;
};
